import React, { useState, useEffect } from "react";
import { Button, TextField, Box } from "@mui/material";
import AddEdit from "./addEdit";
import List from "./list";
import getFilterServices from '../../../services/getFilterServices'

const ManualJournal = () => {
  const [open, setOpen] = useState(false);
  const [dialogType, setDialogType] = useState("add");
  const [editValue, setEditValue] = useState(null);
  const [fetchedData, setFetchedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVal, setFilterVal] = useState({
    search: "",
    page: 1,
    limit: 10
  });
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const setAddManualJournal = () => {
    setDialogType("add");
    setOpen(true);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getFilterServices.GetAllManualJournal();
      console.log("responsemanualjournal", response);
      // Sort the data by createdAt in descending order (newest first)
      const sortedData = (response || []).sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB - dateA;
      });
      setFetchedData(sortedData);
      // Initial filtered data is the same as fetched data
      setFilteredData(sortedData);
      setTotalPages(Math.ceil((sortedData.length || 0) / filterVal.limit));
    } catch (error) {
      console.error("Error fetching manual journals:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setFilterVal(prev => ({
      ...prev,
      page: newPage
    }));
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setFilterVal(prev => ({
      ...prev,
      search: searchValue,
      page: 1, // Reset to first page when searching
    }));

    // Filter the data based on search value
    const filtered = fetchedData.filter(item => 
      item.journalName.toLowerCase().includes(searchValue)
    );
    setFilteredData(filtered);
    // Update total pages based on filtered data
    setTotalPages(Math.ceil((filtered.length || 0) / filterVal.limit));
  };

  useEffect(() => {
    fetchData();
  }, []); // Only fetch data on component mount

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center my-3">
        <h3> Journal</h3>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <TextField
            size="small"
            label="Search Journal"
            variant="outlined"
            value={filterVal.search}
            onChange={handleSearch}
            sx={{ width: '300px' }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={setAddManualJournal}
          >
            Add Journal
          </Button>
        </Box>
      </div>

      <AddEdit
        open={open}
        setOpen={setOpen}
        dialogType={dialogType}
        editValue={editValue}
        setEditValue={setEditValue}
        fetchData={fetchData}
      />

      <List
        open={open}
        setOpen={setOpen}
        dialogType={dialogType}
        setDialogType={setDialogType}
        editValue={editValue}
        setEditValue={setEditValue}
        fetchedData={filteredData} // Pass filtered data instead of fetched data
        filterVal={filterVal}
        setFilterVal={setFilterVal}
        fetchData={fetchData}
        totalPages={totalPages}
        currentPage={filterVal.page}
        onPageChange={handlePageChange}
        loading={loading}
      />
    </div>
  );
};

export default ManualJournal; 